"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _Notification = require("../Notification");
var _MessageBubble = require("../../molecules/MessageBubble");
var _MessageAudio = require("../MessageAudio");
var _SecurityBox = _interopRequireDefault(require("../../ui/SecurityBox"));
var _MessageImage = _interopRequireDefault(require("../../ui/MessageImage"));
var _SafetyMessage = _interopRequireDefault(require("../SafetyMessage"));
var _AlreadySoldTip = _interopRequireDefault(require("../AlreadySoldTip"));
var _messageUtil = require("../../../helpers/messageUtil");
var _graphemeSplitter = _interopRequireDefault(require("grapheme-splitter"));
var _dateutil = require("../../../helpers/dateutil");
var _AutoOpenTip = require("../AutoOpenTip.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Message = function Message(_ref) {
  var message = _ref.message,
    myAccountId = _ref.myAccountId,
    listId = _ref.listId,
    isAdview = _ref.isAdview,
    isAutoOpen = _ref.isAutoOpen,
    partner = _ref.partner;
  var idMessage = message.id,
    sender = message.sender,
    status = message.status,
    text = message.text,
    timestamp = message.timestamp,
    customType = message.customType,
    roomname = message.roomname,
    textMasks = message.textMasks,
    notificationData = message.notificationData,
    _message$extensions = message.extensions,
    extensions = _message$extensions === void 0 ? [] : _message$extensions;
  var isMine = myAccountId === sender;
  var date = new Date(parseInt(timestamp / 1000));
  var isEmoji = (0, _messageUtil.validateEmoji)(text);
  var numberEmoji = 0;
  if (isEmoji) {
    var splitterEmoji = new _graphemeSplitter["default"]().splitGraphemes(text);
    numberEmoji = splitterEmoji.length;
  }
  var _splitCustomType = (0, _messageUtil.splitCustomType)(customType),
    type = _splitCustomType.type,
    subType = _splitCustomType.subType;
  switch (type) {
    case 'normal':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageBubble.MessageBubble, {
          isMine: isMine,
          masks: textMasks,
          idMessage: idMessage,
          status: status,
          time: (0, _dateutil.getTime)(date),
          text: text,
          isEmoji: isEmoji,
          numberEmoji: numberEmoji
        })
      });
    case 'typing':
      return !isMine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageBubble.MessageBubble, {
        isMine: isMine,
        isTyping: true
      });
    case 'image':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageImage["default"], {
        isMine: isMine,
        message: message,
        time: (0, _dateutil.getTime)(date),
        idMessage: idMessage,
        status: status,
        isAdview: isAdview,
        children: text
      });
    case 'audio':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageAudio.MessageAudio, {
          time: (0, _dateutil.getTime)(date),
          text: text,
          extensions: extensions,
          isMine: isMine,
          isAdview: isAdview,
          status: status
        });
      }
    case 'sys_safety':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SafetyMessage["default"], {
        type: subType,
        sender: sender,
        receiver: myAccountId,
        children: text
      });
    case 'security':
      if (isAutoOpen) {
        if (partner.online === undefined) return null;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AutoOpenTip.AutoOpenTip, {
          partner: partner,
          listId: listId
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SecurityBox["default"], {});
    case 'sys_messaging':
      {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AlreadySoldTip["default"], {
          listId: listId,
          roomname: roomname,
          time: (0, _dateutil.getTime)(date)
        });
      }
    case 'sys_notifications':
      {
        var isSecurity = subType === 'security_auto' || subType === 'security_generic';
        if (isSecurity) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SecurityBox["default"], {});
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Notification.Notification, {
          type: subType,
          message: text,
          data: notificationData,
          time: (0, _dateutil.getTime)(date),
          idMessage: idMessage,
          listId: listId,
          sender: sender
        });
      }
    default:
      return null;
  }
};
Message.propTypes = {
  message: _propTypes.object.isRequired,
  myAccountId: _propTypes.string.isRequired,
  listId: _propTypes.string.isRequired,
  isAdview: _propTypes.bool.isRequired,
  isAutoOpen: _propTypes.bool.isRequired
};
var _default = exports["default"] = Message;